<mat-toolbar>
  <mat-icon mat-list-icon>dashboard</mat-icon>
  <span class="container-fluid">
    <h1>Dashboard - Uppdaterad - {{lastReload | date: 'HH:mm:ss'}}</h1>
  </span>
</mat-toolbar>

<div class="col">
  <div class="col1">
    <div class="colheader">
      <mat-icon class="icon-bottom">flight_land</mat-icon> Ankomster:
      <mat-icon class="icon-bottom"
        [ngStyle]="{color:totalArrivalPickups > 0?'green':'black'}">emoji_people</mat-icon>{{totalArrivalPickups}} -
      {{totalArrivalPersons}}
    </div>
    @if (orderShuttlesPickupArrival) {
    <table mat-table [dataSource]="orderShuttlesPickupArrival">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let order">
          *** {{order.lastName}}
          @if (order.hasDevice) {
          <mat-icon class="icon-bottom icon-scaled">mobile_friendly</mat-icon>
          }
          @if (order.extra?.pressedButtonInApp) {
          <mat-icon class="icon-bottom icon-scaled">waving_hand</mat-icon>
          }
          @if (isRedKeyStatus(order.keyStatus) || isGreenKeyStatus(order.keyStatus)) {
          <mat-icon class="icon-bottom"
            [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(order.keyStatus) ? 'red' : (isGreenKeyStatus(order.keyStatus) ? 'green' : '')}">key
          </mat-icon>
          @if (order.orderSafe?.hookNo) {
          <span class="key-hook-number">{{ "(Hook No: " + order.orderSafe.hookNo + ")" }}</span>
          }
          }
          @if (isHotel(order)) {
          <mat-icon class="icon-bottom icon-scaled icon-scaled--middle">hotel</mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="orderParkingParkingSiteName">
        <th mat-header-cell *matHeaderCellDef> Till </th>
        <td mat-cell *matCellDef="let order">
          @if (order?.orderParkingParkingSiteName) {
          <span>
            @let hotelName = displayHotelName(order.organizationId);
            @if(hotelName){
            {{hotelName}}
            }@else{
            @let parking = removeLastPart($safeNavigationMigration(order?.orderParkingParkingSiteName));
            <span [style.color]="parking === 'FP2' ? 'red' : 'inherit'">
              {{ parking }}
            </span>
            }
          </span>
          }
          @if (!order?.orderParkingParkingSiteName) {
          <span> {{displayRouteName(order)}}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef> Tid </th>
        <td mat-cell *matCellDef="let order">
          <span [ngStyle]="{color:order.isReadyForPickup?'green':'black'}">
            @if (order.shuttleDateNew) {
            <span title="{{order.shuttleDateNew | date:'yyyy-MM-dd HH:mm'}}">{{order.shuttleDateNew | date:'HH:mm'}}
            </span>
            }
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="terminal">
        <th mat-header-cell *matHeaderCellDef> Från </th>
        <td mat-cell *matCellDef="let order">
          @if (order.arrivalVM) {
          <span
            [ngStyle]="{color:order.arrivalVM.terminalName=='Terminal 5'||order.arrivalVM.terminalName=='Terminal 4'?'black':'red'}">{{order.arrivalVM.terminalName}}</span>
          }
          @if (!order.arrivalVM) {
          <span [ngStyle]="{color:order.terminal=='T5'||order.terminal=='T4'?'black':'red'}">{{order.terminal}}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="isReadyForPickup">
        <th mat-header-cell *matHeaderCellDef> isReadyForPickup </th>
        <td mat-cell *matCellDef="let order">{{order.isReadyForPickup}}</td>
      </ng-container>
      <ng-container matColumnDef="passengers">
        <th mat-header-cell *matHeaderCellDef> PAX </th>
        <td mat-cell *matCellDef="let order">{{order.passengers}}</td>
      </ng-container>
      <ng-container matColumnDef="orderNr">
        <th mat-header-cell *matHeaderCellDef> OrderNr </th>
        <td mat-cell *matCellDef="let order">{{order.orderNr}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsArrival"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsArrival;"
        [ngClass]="{'hotel-row': isHotel(row), 'non-hotel-row': !isHotel(row)}"
        (click)="goToOrder($safeNavigationMigration(row?.orderId))"></tr>
    </table>
    }

    <div class="colheaderSecond">
      <mat-icon class="icon-bottom">flight_land</mat-icon> Övriga Ankomster:
    </div>
    @if (orderShuttlesOtherArrival) {
    <table mat-table [dataSource]="orderShuttlesOtherArrival">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let order">
          *** {{order.lastName}}
          @if (order.hasDevice) {
          <mat-icon class="icon-bottom icon-scaled">mobile_friendly</mat-icon>
          }
          @if (order.extra?.pressedButtonInApp) {
          <mat-icon class="icon-bottom icon-scaled">waving_hand</mat-icon>
          }
          @if (isRedKeyStatus(order.keyStatus) || isGreenKeyStatus(order.keyStatus)) {
          <mat-icon class="icon-bottom"
            [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(order.keyStatus) ? 'red' : (isGreenKeyStatus(order.keyStatus) ? 'green' : '')}">key
          </mat-icon>
          @if (order.orderSafe?.hookNo) {
          <span class="key-hook-number">{{ "(Hook No: " + order.orderSafe.hookNo + ")" }}</span>
          }
          }
          @if (isHotel(order)) {
          <mat-icon class="icon-bottom icon-scaled icon-scaled--middle">hotel</mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="orderParkingParkingSiteName">
        <th mat-header-cell *matHeaderCellDef> Till </th>
        <td mat-cell *matCellDef="let order">
          @if (order?.orderParkingParkingSiteName) {
          <span>
            @let hotelName = displayHotelName(order.organizationId);
            @if(hotelName){
            {{hotelName}}
            }@else{
            @let parking = removeLastPart($safeNavigationMigration(order?.orderParkingParkingSiteName));
            <span [style.color]="parking === 'FP2' ? 'red' : 'inherit'">
              {{ parking }}
            </span>
            }
          </span>
          }
          @if (!order?.orderParkingParkingSiteName) {
          <span> {{displayRouteName(order)}}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef> Tid </th>
        <td mat-cell *matCellDef="let order">
          <span [ngStyle]="{color:order.isReadyForPickup?'green':'black'}">
            @if (order.shuttleDateNew) {
            <span title="{{order.shuttleDateNew | date:'yyyy-MM-dd HH:mm'}}">{{order.shuttleDateNew | date:'HH:mm'}}
            </span>
            }
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="terminal">
        <th mat-header-cell *matHeaderCellDef> Från </th>
        <td mat-cell *matCellDef="let order">
          @if (order.arrivalVM) {
          <span
            [ngStyle]="{color:order.arrivalVM.terminalName=='Terminal 5'||order.arrivalVM.terminalName=='Terminal 4'?'black':'red'}">{{order.arrivalVM.terminalName}}</span>
          }
          @if (!order.arrivalVM) {
          <span [ngStyle]="{color:order.terminal=='T5'||order.terminal=='T4'?'black':'red'}">{{order.terminal}}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="isReadyForPickup">
        <th mat-header-cell *matHeaderCellDef> isReadyForPickup </th>
        <td mat-cell *matCellDef="let order">{{order.isReadyForPickup}}</td>
      </ng-container>
      <ng-container matColumnDef="passengers">
        <th mat-header-cell *matHeaderCellDef> PAX </th>
        <td mat-cell *matCellDef="let order">{{order.passengers}}</td>
      </ng-container>
      <ng-container matColumnDef="orderNr">
        <th mat-header-cell *matHeaderCellDef> OrderNr </th>
        <td mat-cell *matCellDef="let order">{{order.orderNr}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsArrival"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsArrival;"
        [ngClass]="{'hotel-row': isHotel(row), 'non-hotel-row': !isHotel(row)}"
        (click)="goToOrder($safeNavigationMigration(row?.orderId))"></tr>
    </table>
    }
  </div>
  <div class="col2">
    <div class="colheader">
      <mat-icon class="icon-bottom">flight_takeoff</mat-icon>Avgångar:
      <mat-icon class="icon-bottom"
        [ngStyle]="{color:totalDeparturePickups > 0?'green':'black'}">emoji_people</mat-icon> {{totalDeparturePickups}}
      - {{totalDeparturePersons}}
    </div>

    @if (orderShuttlesPickupDeparture) {
    <table mat-table [dataSource]="orderShuttlesPickupDeparture">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let order">
          *** {{order.lastName}}
          @if (order.hasDevice) {
          <mat-icon class="icon-bottom icon-scaled">mobile_friendly</mat-icon>
          }
          @if (order.extra?.pressedButtonInApp) {
          <mat-icon class="icon-bottom icon-scaled">waving_hand</mat-icon>
          }
          @if (isRedKeyStatus(order.keyStatus) || isGreenKeyStatus(order.keyStatus)) {
          <mat-icon class="icon-bottom"
            [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(order.keyStatus) ? 'red' : (isGreenKeyStatus(order.keyStatus) ? 'green' : '')}">key
          </mat-icon>
          @if (order.orderSafe?.hookNo) {
          <span class="key-hook-number">{{ "(Hook No: " + order.orderSafe.hookNo + ")" }}</span>
          }
          }
          @if (isHotel(order)) {
          <mat-icon class="icon-bottom icon-scaled icon-scaled--middle">hotel</mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="orderParkingParkingSiteName">
        <th mat-header-cell *matHeaderCellDef> Från </th>
        <td mat-cell *matCellDef="let order">
          @if (order?.orderParkingParkingSiteName) {
          <span>
            @let hotelName = displayHotelName(order.organizationId);
            @if(hotelName){
            {{hotelName}}
            }@else{
            @let parking = removeLastPart($safeNavigationMigration(order?.orderParkingParkingSiteName));
            <span [style.color]="parking === 'FP2' ? 'red' : 'inherit'">
              {{ parking }}
            </span>
            }
          </span>
          }
          @if (!order?.orderParkingParkingSiteName) {
          <span> {{displayRouteName(order)}}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef> Tid </th>
        <td mat-cell *matCellDef="let order">
          <span [ngStyle]="{color:order.isReadyForPickup?'green':'black'}">
            @if (order.shuttleDateNew) {
            <span title="{{order.shuttleDateNew | date:'yyyy-MM-dd HH:mm'}}">{{order.shuttleDateNew | date:'HH:mm'}}
            </span>
            }
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="terminal">
        <th mat-header-cell *matHeaderCellDef> Till </th>
        <td mat-cell *matCellDef="let order">
          @if (order.departureVM) {
          <span>{{order.departureVM.terminalName}}</span>
          }
          @if (!order.departureVM) {
          <span>{{order.terminal}}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="isReadyForPickup">
        <th mat-header-cell *matHeaderCellDef> isReadyForPickup </th>
        <td mat-cell *matCellDef="let order">{{order.isReadyForPickup}}</td>
      </ng-container>
      <ng-container matColumnDef="passengers">
        <th mat-header-cell *matHeaderCellDef> PAX </th>
        <td mat-cell *matCellDef="let order">{{order.passengers}}</td>
      </ng-container>
      <ng-container matColumnDef="orderNr">
        <th mat-header-cell *matHeaderCellDef> OrderNr </th>
        <td mat-cell *matCellDef="let order">{{order.orderNr}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsDeparture"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsDeparture;"
        [ngClass]="{'hotel-row': isHotel(row), 'non-hotel-row': !isHotel(row)}"
        (click)="goToOrder($safeNavigationMigration(row?.orderId))"></tr>
    </table>
    }

    <div class="colheaderSecond">
      <mat-icon class="icon-bottom">flight_takeoff</mat-icon>Övriga avgångar:
    </div>

    @if (orderShuttlesOtherDeparture) {
    <table mat-table [dataSource]="orderShuttlesOtherDeparture">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let order">
          *** {{order.lastName}}
          @if (order.hasDevice) {
          <mat-icon class="icon-bottom icon-scaled">mobile_friendly</mat-icon>
          }
          @if (order.extra?.pressedButtonInApp) {
          <mat-icon class="icon-bottom icon-scaled">waving_hand</mat-icon>
          }
          @if (isRedKeyStatus(order.keyStatus) || isGreenKeyStatus(order.keyStatus)) {
          <mat-icon class="icon-bottom"
            [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(order.keyStatus) ? 'red' : (isGreenKeyStatus(order.keyStatus) ? 'green' : '')}">key
          </mat-icon>
          @if (order.orderSafe?.hookNo) {
          <span class="key-hook-number">{{ "(Hook No: " + order.orderSafe.hookNo + ")" }}</span>
          }
          }
          @if (isHotel(order)) {
          <mat-icon class="icon-bottom icon-scaled icon-scaled--middle">hotel</mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="orderParkingParkingSiteName">
        <th mat-header-cell *matHeaderCellDef> Från </th>
        <td mat-cell *matCellDef="let order">
          @if (order?.orderParkingParkingSiteName) {
          <span>
            @let hotelName = displayHotelName(order.organizationId);
            @if(hotelName){
            {{hotelName}}
            }@else{
            @let parking = removeLastPart($safeNavigationMigration(order?.orderParkingParkingSiteName));
            <span [style.color]="parking === 'FP2' ? 'red' : 'inherit'">
              {{ parking }}
            </span>
            }
          </span>
          }
          @if (!order?.orderParkingParkingSiteName) {
          <span> {{displayRouteName(order)}}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef> Tid </th>
        <td mat-cell *matCellDef="let order">
          <span [ngStyle]="{color:order.isReadyForPickup?'green':'black'}">
            @if (order.shuttleDateNew) {
            <span title="{{order.shuttleDateNew | date:'yyyy-MM-dd HH:mm'}}">{{order.shuttleDateNew |
              date:'HH:mm'}}</span>
            }
            @if (!order.shuttleDateNew) {
            <span title="{{order.shuttleDate | date:'yyyy-MM-dd HH:mm'}}">{{order.shuttleDate | date:'HH:mm'}}</span>
            }
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="terminal">
        <th mat-header-cell *matHeaderCellDef> Till </th>
        <td mat-cell *matCellDef="let order">
          @if (order.departureVM) {
          <span>{{order.departureVM.terminalName}}</span>
          }
          @if (!order.departureVM) {
          <span>{{order.terminal}}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="isReadyForPickup">
        <th mat-header-cell *matHeaderCellDef> isReadyForPickup </th>
        <td mat-cell *matCellDef="let order">{{order.isReadyForPickup}}</td>
      </ng-container>
      <ng-container matColumnDef="passengers">
        <th mat-header-cell *matHeaderCellDef> PAX </th>
        <td mat-cell *matCellDef="let order">{{order.passengers}}</td>
      </ng-container>
      <ng-container matColumnDef="orderNr">
        <th mat-header-cell *matHeaderCellDef> OrderNr </th>
        <td mat-cell *matCellDef="let order">{{order.orderNr}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsDeparture"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsDeparture;"
        [ngClass]="{'hotel-row': isHotel(row), 'non-hotel-row': !isHotel(row)}"
        (click)="goToOrder($safeNavigationMigration(row?.orderId))"></tr>
    </table>
    }
  </div>
</div>